export enum GameTrophyStatus {
  NORMAL,
  HIDDEN
}
